import moment, { Moment } from 'moment'

///////////////////////////////////
// EVInvoiceBuilding
///////////////////////////////////

export interface EVInvoiceBuildingData {
  name: string
  address: string
  roomName: string
  evRoomName: string
}

export class EVInvoiceBuilding {
  declare name: string
  declare address: string
  declare roomName: string
  declare evRoomName: string

  constructor(params: EVInvoiceBuildingData) {
    Object.assign(this, params)
  }
}

///////////////////////////////////
// EVPreviousInvoice
///////////////////////////////////

export interface EVPreviousInvoiceData {
  consumption: number
  billingAmount: number
  date: string
}

export class EVPreviousInvoice {
  declare consumption: number
  declare billingAmount: number
  declare date: Moment

  constructor(params: EVPreviousInvoiceData) {
    Object.assign(this, params)
    this.date = moment(params.date)
  }
}

///////////////////////////////////
// EVPlanStep
///////////////////////////////////

export interface EVPlanStepData {
  startValue: number
  endValue: number | null
  price: number
}

export class EVPlanStep {
  declare startValue: number
  declare endValue: number | null
  declare price: number

  constructor(params: EVPlanStep) {
    Object.assign(this, params)
  }
}

///////////////////////////////////
// EVInvoice
///////////////////////////////////

export type EVInvoiceData = {
  meterReadingDay: number
  consumption: number
  billingAmount: number
  consumptionTaxPrice: number
  userCode: string | null
  userName: string | null

  building: EVInvoiceBuildingData
  groupName: string | null
  publishedAt: string | null
  previousMeterReadOn: string
  meterReadOn: string
  date: string
  userHonorific: string

  previousData: EVPreviousInvoiceData | null

  consumptionTax: number
  evPlanSteps: EVPlanStepData[]
}

export default class EVInvoice {
  declare meterReadingDay: number
  declare consumption: number
  declare billingAmount: number
  declare consumptionTaxPrice: number
  declare userCode: string | null
  declare userName: string | null

  declare building: EVInvoiceBuilding

  declare groupName: string | null
  declare publishedAt: Moment | null
  declare previousMeterReadOn: Moment
  declare meterReadOn: Moment
  declare date: Moment
  declare userHonorific: string

  declare previousData: EVPreviousInvoice | null

  declare consumptionTax: number
  declare evPlanSteps: EVPlanStep[]

  // Computed properties --------------------------------------------------------------

  getStepFromConsumption(consumption: number) {
    return this.evPlanSteps.find((step) => {
      if (step.endValue === null) return step.startValue <= consumption
      return step.startValue <= consumption && consumption <= step.endValue
    })
  }

  // Constructor -----------------------------------------------------------------------

  constructor(params: EVInvoiceData) {
    Object.assign(this, params)

    this.publishedAt = params.publishedAt ? moment(params.publishedAt) : null
    this.previousMeterReadOn = moment(params.previousMeterReadOn)
    this.meterReadOn = moment(params.meterReadOn)
    this.date = moment(params.date)

    this.building = new EVInvoiceBuilding(params.building)
    this.previousData = params.previousData ? new EVPreviousInvoice(params.previousData) : null
    this.evPlanSteps = params.evPlanSteps.map((step) => new EVPlanStep(step))
  }
}
